import $ from 'jquery';


// function delay(callback, ms) {
//   var timer = 0;
//   return function() {
//     var context = this, args = arguments;
//     clearTimeout(timer);
//     timer = setTimeout(function () {
//       callback.apply(context, args);
//     }, ms || 0);
//   };
// }


// // Example usage:

// $('#input').keyup(delay(function (e) {
//   console.log('Time elapsed!', this.value);
// }, 500));

export default class {
  constructor() {
    this.init();
    this.apiUrl = window._env.config.apiUrl;
    this.url = window._env.config.url;
  }

  init() {
      
    // Toggle form visibility
    $('.search-input.search-input-mobile > button').on('click', function() {
      $('.search-input.search-input-mobile').toggleClass('active');
    });
    

    // Handle Input
    this.$icon = $('.search-icon');
    this.$headerInput = $('.header-search.search-input');
    this.$mobileInput = $('.search-input.search-input-mobile');
    this.$heroInput = $('.hero-content .search-input');
    this.$results = $('.search-results-modal');
    

    // Close form on page click if open
    $(document).mouseup(function (e) {

    var trigger = $('.search-input input');

	if (!trigger.is(e.target) && trigger.has(e.target).length === 0){

    $('.search-input.search-input-mobile').removeClass('active');
    $('.search-results-modal').addClass('d-none');
    // console.log(e.target);
    }
    });



    const { $icon, $headerInput, $mobileInput, $heroInput } = this;

    this.timeout = null;
    var self = this;

    if ($icon && $mobileInput) {

      $mobileInput.on('keyup', function(event) {
        self.handleSearch(event, $mobileInput);
      });

      $heroInput.on('keyup', function(event) {
        self.handleSearch(event, $heroInput);
      });

      $headerInput.on('keyup', function(event) {
        self.handleSearch(event, $headerInput);
      });
    }
  }
  
  
  handleSearch(event, $inputEl) {
    var self = this

    if (event.which === 13) {
      event.preventDefault();
      window.location.href = `/?s=${event.target.value}`
      return;
    }
    clearTimeout(this.timeout);
    this.timeout = setTimeout(function() {
      self.searchKeyword(event.target.value, $inputEl);
  
    // if user pressed enter then navigate to search page
  
    }, 350);
    // if ( event.target.value ) {
    //   typingTimer = setTimeout(self.searchKeyword(event.target.value), doneTypingInterval);
    // }
  }

  searchKeyword(keyword, $inputEl) {
    // set keyword to module prop so we can access it later
    this.keyword = keyword;
    const { apiUrl } = this;

    console.log(apiUrl);
    
    if (keyword) {
      $.ajax(`${apiUrl}search?term=${keyword}`)
        .then(result => JSON.parse(result))
        .then(result => this.appendToDOM(result, $inputEl))

      return;
    }
    this.clearResults();
  }

  appendToDOM(result, $inputEl) {
    console.log(result);
    const {keyword, url} = this;

    const recipes = result.filter(r => typeof(r) !== 'string');
    const tags = result.filter(r => typeof(r) === 'string');
    console.log(tags);

    // build out results and append recipes
    const $recipeList = $inputEl.find('.search-results-modal')
      .removeClass('d-none')
      .empty()
      .append(`<div class="row justify-content-between text-left">
                <div class="col-sm-12">
                <p class="dark-gray pb-2 small strong text-left">${keyword ? `Search for "${keyword}"` : ''}</p>
               </div>
              </div>`)
      .append(`<div class="row justify-content-between text-left search-list-header pb-2">
                 <div class="col-sm-6 text-left p-0"><span class="text-uppercase font-weight-bold text-secondary">Recipes</span></div>
                 <!--<div class="col-sm-6 text-right p-0"><a class="highlighted" href="${url}/browse/recipes">MORE</a></div>-->
                 <div class="col-sm-6 text-right p-0"><a class="highlighted" href="/?s=${keyword}">MORE</a></div>
               </div>`)
      .append(` <div class="row">
                 <div class="col-sm-12">
                   <ul class="search-result-list recipes"></ul>
                 </div>
               </div>`)
      .append(`<div class="row justify-content-between text-left search-list-header pb-2">
                 <div class="col-sm-6 text-left p-0"><span class="text-uppercase font-weight-bold text-secondary">Tags</span></div>
               </div>`)
      .append(` <div class="row">
                 <div class="col-sm-12">
                   <ul class="search-result-list tags"></ul>
                 </div>
               </div>`)
      .find('ul.recipes');

    recipes.forEach(post => {
      $recipeList.append(`
        <li class="search-result text-left pl-2">
            <img class="search-image" src=${post.image} alt="">
            <a href=${post.guid}><span>${post.post_title}</span></a>
        </li>`);
        console.log(post);
    });

    // build out tags
    tags.forEach(tag => {
      $inputEl.find('.search-results-modal').find('ul.tags').append(`
        <li class="search-result text-left pl-2">
            <a class="d-flex justify-content-start align-items-center" href="${this.url}?s=${tag}">
            <svg fill="#B1B3B1" class="svgIcon-use" width="21" height="21"><path d="M4.662 8.72l-1.23 1.23a1.753 1.753 0 0 0 .004 2.477l5.135 5.135c.7.693 1.8.688 2.48.005l1.23-1.23 5.35-5.346c.31-.31.54-.92.51-1.36l-.32-4.29c-.09-1.09-1.05-2.06-2.15-2.14l-4.3-.33c-.43-.03-1.05.2-1.36.51l-.79.8-2.27 2.28-2.28 2.27zm9.826-.98a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z" fill-rule="evenodd"></path></svg><span class="pl-1 strong dark-gray">${tag}</span>
            </a>
        </li>`);
    });
  }

  clearResults() {
    const { $results } = this;

    $results
      .addClass('d-none')
      .empty();
  }
}


// WEBPACK FOOTER //
// ./scripts/modules/search.js